import { render, staticRenderFns } from "./InputButton.vue?vue&type=template&id=14af4398"
import script from "./input-button.js?vue&type=script&lang=js&external"
export * from "./input-button.js?vue&type=script&lang=js&external"
import style0 from "./input-button.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports